/*
 * @Author: wangshengqiang
 * @Date: 2021-04-28 14:14:35
 * @LastEditTime: 2021-06-07 18:01:39
 * @LastEditors: wangshengqiang
 * @Description: 客服按钮组件
 */
import React from 'react';
import classnames from 'classnames';
import Modal from '@/components/Modal';
import { Iconfont } from '@/baseComponents';
import './index.less';
const CustomerService = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs
  } = props;
  const {
    dataSource = [],
    isShow,
    defaultType = 'phone'
  } = attrs;
  if (!isShow) return null;
  const cls = classnames({
    'components-customer-service-render': true // [className]: !!className,

  });
  const curr = dataSource.find((item = {}) => item.type === defaultType) || {};
  const {
    value
  } = curr;

  const onClickPhone = async () => {
    const message = /*#__PURE__*/React.createElement("div", {
      className: "toolbar-telphone-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "content-title"
    }, "\u4F17\u5B89\u5BA2\u670D\u7535\u8BDD"), /*#__PURE__*/React.createElement("div", {
      className: "content-desc"
    }, value));

    const onClickConfirm = () => {
      window.location.href = `tel:${value}`;
      Modal.hide();
    };

    const operations = [{
      children: '取消'
    }, {
      type: 'primary',
      children: '拨打电话',
      onClick: onClickConfirm
    }];
    Modal.show({
      children: message,
      operations
    });
  };

  const onClick = () => {
    if (defaultType === 'phone') {
      onClickPhone();
    } else {
      window.location.href = value;
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    ref: ref,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Iconfont, {
    className: "icon",
    type: "kefu"
  }), /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, "\u5BA2\u670D"));
});
export default CustomerService;